export function showErrorToast(message: string) {
  const container = document.getElementById('mutation-error-toast');
  if (!container) return;
  container.textContent = message;
  container.style.display = 'block';
  container.offsetHeight; // force reflow for animation
  container.classList.add('show');
  setTimeout(() => {
    container.classList.remove('show');
    setTimeout(() => {
      container.style.display = 'none';
    }, 300);
  }, 5000);
}

export function showSuccessToast(message: string) {
  const container = document.getElementById('success-toast');
  if (!container) return;
  container.textContent = message;
  container.style.display = 'block';
  container.offsetHeight; // force reflow for animation
  container.classList.add('show');
  setTimeout(() => {
    container.classList.remove('show');
    setTimeout(() => {
      container.style.display = 'none';
    }, 300);
  }, 5000);
}

/**
 * Persistent, manually-dismissable update banner with a primary action button.
 * Unlike the error/success toasts above it does NOT auto-hide — the user
 * decides when to act (e.g. after saving their work). Idempotent: calling it
 * again while already shown is a no-op. Used for the "new version available"
 * prompt on a stale-chunk preload error, where a blind reload could discard
 * unsaved input.
 */
let updateBannerShown = false;
export function showUpdateBanner(message: string, actionLabel: string, onAction: () => void): void {
  if (updateBannerShown) return;
  if (typeof document === 'undefined') return;
  updateBannerShown = true;

  const banner = document.createElement('div');
  banner.id = 'app-update-banner';
  banner.setAttribute('role', 'status');
  banner.style.cssText =
    'position:fixed;left:50%;bottom:1rem;transform:translateX(-50%);z-index:10000;' +
    'display:flex;align-items:center;gap:0.75rem;max-width:calc(100vw - 2rem);' +
    'padding:0.625rem 0.75rem 0.625rem 1rem;border-radius:0.625rem;background:#1f2937;' +
    'color:#fff;font-size:0.8125rem;box-shadow:0 8px 24px rgba(0,0,0,0.25);';

  const text = document.createElement('span');
  text.textContent = message;
  text.style.cssText = 'flex:1;min-width:0;';

  const actionBtn = document.createElement('button');
  actionBtn.type = 'button';
  actionBtn.textContent = actionLabel;
  actionBtn.style.cssText =
    'flex-shrink:0;padding:0.375rem 0.75rem;border-radius:0.375rem;border:0;' +
    'background:#3b82f6;color:#fff;font-size:0.8125rem;font-weight:600;cursor:pointer;';
  actionBtn.addEventListener('click', onAction);

  const dismissBtn = document.createElement('button');
  dismissBtn.type = 'button';
  dismissBtn.setAttribute('aria-label', 'Dismiss');
  dismissBtn.textContent = '×';
  dismissBtn.style.cssText =
    'flex-shrink:0;width:1.5rem;height:1.5rem;border-radius:0.375rem;border:0;' +
    'background:transparent;color:#9ca3af;font-size:1.125rem;line-height:1;cursor:pointer;';
  dismissBtn.addEventListener('click', () => {
    banner.remove();
    updateBannerShown = false;
  });

  banner.appendChild(text);
  banner.appendChild(actionBtn);
  banner.appendChild(dismissBtn);
  document.body.appendChild(banner);
}
